export default function calculatePts(px: number) {
  return px * 0.43;
}
